import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css'
import logoIconImage from '../../assets/img/register-imgs/register-img.png';

const SignUp = () => {
    return (
        <div className="row g-0">
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center min-vh-100">
                <div className="row w-100 d-flex justify-content-center align-items-center">
                    <div className="col-8">
                        <div className="d-flex align-items-center justify-content-center mb-5">
                        </div> 
                        <form>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="text" placeholder="Full name" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="date" placeholder="Date of birth" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="email" placeholder="Email" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="text" placeholder="Username" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="password" placeholder="Password" />
                                </div>
                            </div>
                            <div className="row mb-4">
                                <div className="col">
                                    <input className="form-control w-100 rounded-pill px-4 login-tb" type="password" placeholder="Confirm Password" />
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col"><span className="login_txt">By clicking "Continue", you agree to our </span><a className="login_link" href="#">Terms of Use.&nbsp;</a><span className="login_txt">Learn about how we process and use your data in our</span><a className="login_link" href="#">&nbsp;Privacy Policy</a><span className="login_txt">&nbsp;and&nbsp;our </span><a className="login_link" href="#">Cookie Policy</a></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">  <div className="col">
                                    <div className="custom-button rounded-pill">
                                        <button className="inner-button  rounded-pill " type="button" >
                                            Register
                                        </button>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col"><span className="login_txt">Already member?</span>
                                <Link className="login_link" to="/">&nbsp;Login</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        <div className="col-12 col-lg-6 p-0 vh-100">
            <img className="img-fluid vh-100 w-100" src={logoIconImage} alt="" />
        </div> 
    </div>
    );
};

export default SignUp;